import {
  AI_Platform_Img,
  Map_Overylay_Img,
  Powered_By_AI_Img,
} from "../../images";
import Partners from "./partners";

function OurProduct() {
  return (
    <section
      className="relative w-full bg-white py-20 bg-top bg-contain bg-no-repeat overflow-hidden"
      style={{
        backgroundImage: `url("${Map_Overylay_Img}")`,
      }}
    >
      <div className="h-[300px] w-[300px] xl:h-[350px] xl:w-[350px] bg-[#7AA8FF80] blur-[130px] absolute top-0 -right-44  md:top-14 md:-left-[15%]"></div>

      <div className="h-[450px] w-[450px] bg-[#7AA8FF80] blur-[130px] absolute bottom-0 -right-[20%] hidden md:block"></div>

      <div className="mx-auto container">
        {/* Header */}
        <div className="mb-10 md;mb-20 text-center">
          <h1 className="mb-2 text-2xl md:text-3xl font-bold tracking-tight xl:text-[36px] text-[#0073FF]">
            Our Product
          </h1>
          <p className="mx-auto max-w-5xl font-normal text-base text-gray-700">
            Our product simplifies your life, delivers results, and grows with
            your needs
          </p>
        </div>

        <div className="space-y-16">
          <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-10 md:grid md:grid-cols-2">
            <img
              src={AI_Platform_Img}
              alt="AI Platform dashboard interface"
              className="h-auto w-full object-cover max-w-[620px]"
            />

            <div className="space-y-3 md:space-y-6">
              <div>
                <h3 className="mb-4 text-lg md:text-2xl font-bold text-black">
                  [AI] Platform
                </h3>
                <p className="text-base md:text-lg leading-relaxed text-[#333333] max-w-2xl">
                  [AI] Platform is a secure retrieval augmented generation (RAG)
                  system for building analytics agents and conversational AI
                  solutions using enterprise datasets..The platform supports
                  fine-tuning and ingestion pipelines, enabling enterprises to
                  build custom agentic applications with governed data.
                </p>
              </div>
              <button className="bg-[#0073FF] py-3 px-6 text-base text-white font-semibold hover:bg-[#0073FF]/70 min-w-[170px] rounded-full mt-2 md:mt-0">
                Explore [AI] Platform
              </button>
            </div>
          </div>

          <div className="flex flex-col items-center justify-between gap-10 md:grid md:grid-cols-2">
            <div className="space-y-3 md:space-y-6">
              <div>
                <h3 className="mb-4 text-lg md:text-2xl font-bold text-black">
                  Powerdby [AI]
                </h3>
                <p className="text-lg leading-relaxed text-[#333333] max-w-2xl">
                  Powerdby[AI] provides both ready-to-deploy AI models and
                  comprehensive development services for African markets. Let’s
                  help you build, deploy and monitor your model in production.
                </p>
              </div>
              <button className="bg-[#0073FF] py-3 px-6 text-base text-white font-semibold hover:bg-[#0073FF]/70 min-w-[170px] rounded-full mt-2 md:mt-0">
                Learn More
              </button>
            </div>

            <img
              src={Powered_By_AI_Img}
              alt="Powerdby AI website interface"
              className="h-auto w-full object-cover max-w-[540px]"
            />
          </div>
        </div>
      </div>

      <section className="container pt-[96px]">
        <div className="space-y-4 mb-8">
          <h2 className="text-black font-extrabold text-[24px] md:text-[32px] text-center">
            Companies We’ve Worked With
          </h2>
          <p className="text-[#020128] text-sm md:text-base text-center">
            We are proud to have worked with leading companies in Africa, to
            help steer their journey towards a data-driven future.
          </p>
        </div>
        <Partners />
      </section>
    </section>
  );
}

export default OurProduct;
